// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top[data-v-bb09312a]{display:flex;position:relative}.top>h2[data-v-bb09312a]{flex:1}.close-button[data-v-bb09312a]{cursor:pointer;display:flex;align-items:center;justify-content:center;padding:2px}.close-button>i[data-v-bb09312a]{font-size:14px;opacity:.5}.close-button[data-v-bb09312a]:hover{background-color:var(--wm-closer-hover-bg)}", ""]);
// Exports
module.exports = exports;
